import Image from 'next/image';
import { SolidButton } from '../Button';
import { H4, P } from '../Text';
import timeIcon from 'assets/svgs/img-time.svg';
import { useTranslation } from 'next-i18next/pages';

import BaseModal from './BaseModal';
import { SearchQueryParams } from 'containers/SearchField';
import useNewSearch from 'hooks/useNewSearch';

interface IExpiredSessionTypeAModalContentProps {
  closeModal: () => void;
  modalOpen: boolean;
  query: SearchQueryParams;
}

const ExpiredSessionTypeAModalContent: React.FC<
  IExpiredSessionTypeAModalContentProps
> = ({ closeModal, modalOpen, query }) => {
  const { t } = useTranslation();
  const { handleNewSearch } = useNewSearch(query);
  return (
    <BaseModal
      closeModal={closeModal}
      modalOpen={modalOpen}
      cancelDisabled
      isExpiredSessionModal>
      <div className="flex flex-col items-center justify-center px-12">
        <Image src={timeIcon} className="w-48 h-48" alt="" />
        <div className="mt-3 text-center sm:mt-0 sm:text-left">
          <H4 className="!text-lg leading-6 font-medium" centered>
            <b>{t('Expired session')}</b>
          </H4>
          <P className="mt-2" centered>
            {t('Start a new search')}
          </P>
        </div>
        <SolidButton
          className="w-full sm:w-3/4 mt-4"
          onClick={() => {
            closeModal();
            handleNewSearch();
          }}>
          {t('New search')}
        </SolidButton>
      </div>
    </BaseModal>
  );
};

export default ExpiredSessionTypeAModalContent;
